<!--
* @Author: zhangping
* @Date: 2026-02-04 10:38:08
* @Description: 巡店记录
-->

<template>
    <div class="cr">
        <Spin fix size="large" v-if="loadings.page">
            <slot name="loading"></slot>
        </Spin>
        <div v-for="(item, index) in cruiseRecord" :key="index" class="mb-20">
            <Alert type="info" size="small" style="width: 600px">
                {{ item.createDate }}
                <span v-if="!!item.distance">距离{{ item.distance }}m</span>
                {{ item.salesmenName }}
            </Alert>
            <viewer :images="item.imgList">
                <span v-for="src in item.imgList" :key="src">
                    <img :src="src" class="cr-img mr-10" />
                </span>
            </viewer>
            <div>{{ item.remark }}</div>
        </div>
        <div v-if="!loadings.page && cruiseRecord.length === 0" class="tac mt-100">暂无巡店记录</div>
    </div>
</template>

<script>
import { apiStoreTour } from '@/api/cruise';
export default {
    name: 'ItemStoreInfo',
    props: {
        storeId: {
            type: String,
            default: '',
        },
    },
    data() {
        return {
            cruiseRecord: [],
            loadings: { page: false },
        };
    },
    mounted() {
        this.getData();
    },
    methods: {
        // 获取数据
        async getData() {
            try {
                this.loadings.page = true;
                const res = await apiStoreTour(this.storeId);
                this.loadings.page = false;
                this.cruiseRecord = res.map((item) => ({
                    ...item,
                    imgList: [item.headImageUrl, item.productListImageUrl, item.roadShowImageUrl].filter((el) => !!el),
                }));
                this.$previewRefresh();
            } catch (error) {
                this.loadings.page = false;
            }
        },
    },
};
</script>

<style scoped lang="less">
.cr {
    .cr-img {
        width: 180px;
        border-radius: 4px;
    }
}
</style>
